import { clamp } from "./chunk-0.jsx";
export function drawIrisEye(ctx, cx, cy, r, {
  openness,
  pupilScale,
  gazeX,
  gazeY,
  iris,
  brow,
  side
}) {
  const isLeft = side === 'left';
  const mirror = isLeft ? -1 : 1;
  const gx = (gazeX || 0) * r * 0.22;
  const gy = (gazeY || 0) * r * 0.18;
  const irisR = r * 0.48;
  const pupilR = irisR * 0.38 * pupilScale;
  ctx.save();
  const scleraGrad = ctx.createRadialGradient(cx - r * 0.2, cy - r * 0.2, r * 0.2, cx, cy, r);
  scleraGrad.addColorStop(0, '#ffffff');
  scleraGrad.addColorStop(1, '#e5e7eb');
  ctx.fillStyle = scleraGrad;
  ctx.beginPath();
  ctx.arc(cx, cy, r, 0, Math.PI * 2);
  ctx.closePath();
  ctx.fill();
  ctx.beginPath();
  ctx.arc(cx, cy, r, 0, Math.PI * 2);
  ctx.clip();
  const ix = cx + gx;
  const iy = cy + gy;
  const irisGrad = ctx.createRadialGradient(ix - irisR * 0.25, iy - irisR * 0.25, irisR * 0.1, ix, iy, irisR);
  irisGrad.addColorStop(0, '#ffffff');
  irisGrad.addColorStop(0.15, iris);
  irisGrad.addColorStop(1, '#0f172a');
  ctx.fillStyle = irisGrad;
  ctx.beginPath();
  ctx.arc(ix, iy, irisR, 0, Math.PI * 2);
  ctx.closePath();
  ctx.fill();
  ctx.save();
  ctx.globalAlpha = 0.18;
  ctx.strokeStyle = '#0b1220';
  ctx.lineWidth = 1;
  for (let i = 0; i < 18; i++) {
    const a = i / 18 * Math.PI * 2;
    ctx.beginPath();
    ctx.moveTo(ix, iy);
    ctx.lineTo(ix + Math.cos(a) * irisR, iy + Math.sin(a) * irisR);
    ctx.stroke();
  }
  ctx.restore();
  ctx.fillStyle = '#000';
  ctx.beginPath();
  ctx.arc(ix, iy, pupilR, 0, Math.PI * 2);
  ctx.closePath();
  ctx.fill();
  ctx.fillStyle = 'rgba(255,255,255,0.55)';
  ctx.beginPath();
  ctx.arc(ix - irisR * 0.25, iy - irisR * 0.25, irisR * 0.14, 0, Math.PI * 2);
  ctx.closePath();
  ctx.fill();
  const close = clamp(1 - openness, 0, 0.98);
  const lidH = close * r * 1.05;
  ctx.fillStyle = '#000';
  ctx.fillRect(cx - r, cy - r, r * 2, lidH);
  ctx.fillRect(cx - r, cy + r - lidH, r * 2, lidH);
  const browTilt = (brow || 0) * mirror;
  if (Math.abs(browTilt) > 0.02) {
    ctx.save();
    ctx.globalAlpha = 0.35;
    ctx.fillStyle = '#000';
    ctx.translate(cx, cy - r * 1.05);
    ctx.rotate(browTilt);
    ctx.fillRect(-r * 0.85, -r * 0.06, r * 1.7, r * 0.12);
    ctx.restore();
  }
  ctx.restore();
}
